import { categories } from '@/mocks/homeData';

export default function CategoryCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
            Browse Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Popular Sugargoo Spreadsheet Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore organized product collections across all major fashion and lifestyle categories
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden hover:border-primary-200 hover:shadow-sm transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-32 md:h-36 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-2 left-2 right-2 flex items-center gap-1.5">
                  <div className="w-6 h-6 flex items-center justify-center rounded-md bg-background-50/90 text-primary-500">
                    <i className={`${cat.icon} w-3.5 h-3.5 flex items-center justify-center`}></i>
                  </div>
                  <span className="text-xs font-medium text-background-50 drop-shadow-sm truncate">
                    {cat.name}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4 flex items-center justify-between">
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-900 transition-colors">
                  View Products
                </span>
                <span className="text-[10px] md:text-xs text-foreground-400 group-hover:text-primary-500 transition-colors">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}